// extracted by mini-css-extract-plugin
module.exports = {"Page":"ComplaintDetail_Page__1qC0k"};